<footer class="legal-wrapper w-full">
  <h4 class="legal-heading">
    <button class="legal-toggle-button" (click)="disableContent()" aria-controls="legal-notes" [attr.aria-expanded]="showContentFlag">
      <mat-icon aria-hidden="true" *ngIf="!showContentFlag">
        <span class="material-icons-outlined">expand_less</span>
      </mat-icon>
      <mat-icon aria-hidden="true" *ngIf="showContentFlag">
        <span class="material-icons-outlined">expand_more</span>
      </mat-icon>
      <span class="text-sm" i18n>HOW MAY I USE THESE PICTURES & VIDEOS?</span>
    </button>
  </h4>
  <div id="legal-notes" class="content-details text-xs" [ngClass]="{ hidden: !showContentFlag }">
    <p class="pt-2 pb-2 m-0" i18n>Copyright - Please note that all the images are subject to copyright and the following conditions apply:</p>
    <ul class="legal-list">
      <li class="legal-list-item" i18n>Photographs may only be used for editorial or private purposes</li>
      <li class="legal-list-item" i18n>Please see the individual copyright text</li>
      <li class="legal-list-item" i18n>Photographs may not be manipulated or combined with other images</li>
      <li class="legal-list-item" i18n>Photographs may only be used for making purposes with Authorization in writing from Lufthansa</li>
      <li class="legal-list-item" i18n>The image data may not be transferred to third parties</li>
      <li class="legal-list-item" i18n>Permanently storing images on electronic systems is not permitted</li>
      <li class="legal-list-item" i18n>Images cannot be used after expiration date and must be deleted from all electronic storage media after expiration</li>
    </ul>
  </div>
</footer>
